export default __webpack_public_path__ + "static/media/group-lframe-card-mobile.8161e341.png";